// import React, { useEffect } from 'react';
// import { Modal, Form, Select, Input, Button, Typography, Avatar } from 'antd';
// import ColorHash from 'color-hash';
// import {
//   fetchStaffingData,
//   fetchStaffingUsers,
//   updateStaffAssignment
// } from '../redux/slice';
// import { useDispatch } from 'react-redux';

// const { Text } = Typography;
// const { Option } = Select;
// const colorHash = new ColorHash({ lightness: 0.7 });

// const getInitials = (name) => {
//   if (!name) return 'U';
//   return name
//     .split(' ')
//     .map((word) => word[0])
//     .join('')
//     .toUpperCase();
// };

// const EditMemberModal = ({ visible, onClose, onSubmit, project, member }) => {
//   const dispatch = useDispatch();
//   const [form] = Form.useForm();

//   console.log(member.role, member.utilization_type);
//   console.log(member);
//   useEffect(() => {
//     if (visible && project && member) {
//       form.setFieldsValue({
//         employee: member.name,
//         project: project.projectTitle,
//         client: project.company,
//         utilization: member.progress
//       });
//     } else {
//       form.resetFields();
//     }
//   }, [visible, project, member, form]);

//   const handleFinish = (values) => {
//     const payload = {
//       id: member.id,
//       utilization_percentage: Number(values.utilization)
//     };
//     console.log(payload);
//     // onSubmit(payload);
//     dispatch(updateStaffAssignment(payload)).then((res) => {
//       if (res?.payload?.success) {
//         dispatch(fetchStaffingData());
//         dispatch(fetchStaffingUsers());
//       }
//     });
//     form.resetFields();
//     onClose();
//   };

//   const handleCancel = () => {
//     form.resetFields();
//     // setCurrentUtilization(null);
//     onClose();
//   };

//   return (
//     <Modal
//       visible={visible}
//       // title="Edit Member"
//       onCancel={onClose}
//       footer={null}
//       centered
//       destroyOnClose
//     >
//       <Form form={form} layout="vertical" onFinish={handleFinish}>
//         <h3
//           className="text-[rgba(0,0,0,0.85)]"
//           style={{ fontWeight: 'bold', marginTop: '-7px' }}
//         >
//           Edit Member
//         </h3>
//         <Form.Item label="Employee" name="employee">
//           <Input disabled />
//         </Form.Item>

//         <Form.Item label="Project" name="project">
//           <Input disabled />
//         </Form.Item>

//         <Form.Item label="Client" name="client">
//           <Input disabled />
//         </Form.Item>

//         <Form.Item label="Utilization %" name="utilization">
//           <Input type="number" placeholder="e.g., 50" addonAfter="%" min={1} />
//         </Form.Item>

//         <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
//           <Button
//             onClick={handleCancel}
//             className="font-bold border border-blue-500 text-blue-500"
//           >
//             Cancel
//           </Button>
//           <Button className="font-bold" type="primary" htmlType="submit">
//             Edit Member
//           </Button>
//         </div>
//       </Form>
//     </Modal>
//   );
// };

// export default EditMemberModal;

import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Button, Typography, Select } from 'antd';
import {
  fetchStaffingData,
  fetchStaffingUsers,
  updateStaffAssignment,
  fetchUserRoles
} from '../redux/slice';
import { useDispatch } from 'react-redux';

const { Text } = Typography;
const { Option } = Select;

const EditMemberModal = ({ visible, onClose, project, member }) => {
  console.log(project, 'project');
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const [roles, setRoles] = useState([]);
  const [utilizationType, setUtilizationType] = useState('active');

  useEffect(() => {
    if (visible) {
      dispatch(fetchUserRoles()).then((res) => {
        if (res?.payload?.success) {
          setRoles(res.payload.data || []);
        }
      });
    }
  }, [dispatch, visible]);

  useEffect(() => {
    if (visible && project && member) {
      form.setFieldsValue({
        employee: member.name,
        project: project.projectTitle,
        client: project.company,
        utilization: member.progress,
        role: roles.find((r) => r.role === member.role)?.id
      });
      setUtilizationType(member.utilization_type || 'active');
    } else {
      form.resetFields();
    }
  }, [visible, project, member, form, roles]);

  const handleFinish = (values) => {
    const payload = {
      id: member.id,
      utilization_percentage: Number(values.utilization),
      project_role_master_id: values.role,
      utilization_type: utilizationType,
      project_id: project.projectId
    };
    console.log('payload', payload);

    dispatch(updateStaffAssignment(payload)).then((res) => {
      if (res?.payload?.success) {
        dispatch(fetchStaffingData());
        dispatch(fetchStaffingUsers());
      }
    });

    form.resetFields();
    onClose();
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      centered
      destroyOnClose
      width={500}
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <h3
          className="text-[rgba(0,0,0,0.85)]"
          style={{ fontWeight: 'bold', marginTop: '-7px' }}
        >
          Edit Member
        </h3>

        <Form.Item label="Employee" name="employee">
          <Input disabled />
        </Form.Item>

        <Form.Item label="Project" name="project">
          <Input disabled />
        </Form.Item>

        <Form.Item label="Client" name="client">
          <Input disabled />
        </Form.Item>

        <Form.Item
          label="Utilization %"
          name="utilization"
          // rules={[
          //   { required: true, message: 'Please enter utilization percentage' },
          //   { type: 'number', min: 1, message: 'Must be at least 1%' }
          // ]}
        >
          <Input type="number" placeholder="e.g., 50" addonAfter="%" min={1} />
        </Form.Item>

        <Form.Item
          label="Role"
          name="role"
          rules={[{ required: true, message: 'Please select a role' }]}
        >
          <Select placeholder="Select a Role" showSearch>
            {roles.map((role) => (
              <Option key={role.id} value={role.id}>
                {role.role}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Utilization Type">
          <div className="flex gap-2">
            <Button
              style={{
                height: '24px',
                padding: '0px 10px 5px',
                backgroundColor:
                  utilizationType === 'active' ? '#0653fa' : undefined,
                color: utilizationType === 'active' ? 'white' : undefined,
                borderColor:
                  utilizationType === 'active' ? '#0653fa' : undefined
              }}
              type="default"
              onClick={() => setUtilizationType('active')}
            >
              Active
            </Button>
            <Button
              style={{
                height: '24px',
                padding: '0px 10px 5px',
                backgroundColor:
                  utilizationType === 'upcoming' ? '#0653fa' : undefined,
                color: utilizationType === 'upcoming' ? 'white' : undefined,
                borderColor:
                  utilizationType === 'upcoming' ? '#0653fa' : undefined
              }}
              type="default"
              onClick={() => setUtilizationType('upcoming')}
            >
              Upcoming
            </Button>
          </div>
        </Form.Item>

        <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
          <Button
            onClick={handleCancel}
            className="font-bold border border-blue-500 text-blue-500"
          >
            Cancel
          </Button>
          <Button className="font-bold" type="primary" htmlType="submit">
            Edit Member
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default EditMemberModal;
